export enum Routes {
  Report,
  UserReport,
  UserRequestHistory,
  PendingUserRequestHistory,
  Dispatcher,
  DispatcherBeta,
  Map,
  SignOut,
  GroupTripRequest,
  GroupTripPasagers,
  GroupTripTrips,
  Banner,
  Driver,
  GroupTripsClients,
  MultipleLoad,
  IndexAdminPanel,
  Departments,
  PaymentHistory,
  PrivacyPolicies,
  GenerateQR,
  GuestTrips,
  AirportQRList,
  Regions,
  AdminConfiguration,
  RegionPrices,
  EmptyTrips,
  Currencies,
  ServiceTypes,
  ServiceTiers,
  NotifyPassengers,
  GenerateReferralQR,
  PushNotifications,
  ReportsDashboard,
  Shuttles,
  ScrapEmails,
  RegistrationCodes,
  TripParkingReport,
  Countries,
  TripRequestAnalytics,
  InternationalPricing,
}
